<template>
  <div class="webdatalist">
    <div class="showLargeScreenOnly">
      <div v-for="group in clearanceGroups">
        <f7-block-title v-if="!isEmpty(filteredUserAccounts[group.clearance])">{{ group.label }}</f7-block-title>
        <f7-list media-list>
          <f7-list-group v-for="(group, key) in filteredUserAccounts[group.clearance]" :key="key">
            <f7-list-item :title="key" group-title></f7-list-item>
              <li v-for="data in group" :key="data.id">
                <div class="item-content boxRequest">
                  <div class="item-inner" @click="editAccountMember(data)">
                    <div class="item-title">{{ data.login }}</div>
                    <div class="item-subtitle">{{ data.active }}</div>
                  </div>
                  <div class="item-media">
                    <button class="button-swipe-out" @click="removeAccountMemberWeb(data)">
                      <!-- <i class="fa fa-times-circle button-delete" ></i> -->
                      <f7-icon f7="close" class="button-delete"
                        :disabled="$engine.rights.rightIs('business_members_supprimer', false)"
                        :style="$engine.rights.rightIs('business_members_supprimer', false) ? {'color':'grey'} : {}">
                      </f7-icon>
                    </button>
                  </div>
                </div>
              </li>
            </f7-list-group>
          </f7-list>
      </div>
      </div>
      <div class="showSmallScreenOnly">
        <div v-for="group in clearanceGroups">
          <f7-block-title v-if="!isEmpty(filteredUserAccounts[group.clearance])">{{ group.label }}</f7-block-title>
          <f7-list media-list>
            <f7-list-group v-for="(group, key) in filteredUserAccounts[group.clearance]" :key="key">
              <f7-list-item :title="key" group-title></f7-list-item>
                  <li v-for="data in group" :key="data.id" class="swipeout">
                    <div class="item-content boxRequest swipeout-content">
                      <div class="item-inner" @click="editAccountMemberMobile(data)">
                        <div class="item-title">{{ data.login }}</div>
                        <div class="item-subtitle">{{ data.active }}</div>
                      </div>
                    </div>
                    <div class="swipeout-actions-right">
                      <a class="swipeout-create action3" href="#" @click="editAccountMemberMobile(data)">
                        Edit
                      </a>
                      <a class="action4"
                        :class="$engine.rights.rightIs('business_members_supprimer', false) ? '' : 'swipeout-delete'"
                        :style="$engine.rights.rightIs('business_members_supprimer', false) ? 'background-color:grey' : ''"
                        href="#" @click="removeAccountMember(data)" delete>
                        Remove
                      </a>
                    </div>
                  </li>
              </f7-list-group>
            </f7-list>
        </div>

      </div>
  </div>
</template>

<script>
import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'
import _ from 'lodash'

export default {
  name: 'AccountMembersList',
  props: ['filterBy', 'userAccounts'],
  data: () => {
    return {
      list: '0'
    }
  },
  computed: {
    clearanceGroups () {
      return [
        {clearance: 1, label: this.$i18n.t('businessMembers.admnstrtrs')},
        {clearance: 2, label: this.$i18n.t('businessMembers.mngrs')},
        {clearance: 3, label: this.$i18n.t('businessMembers.usr')},
        {clearance: 0, label: this.$i18n.t('businessMembers.no_accss')}
      ]
    },
    filteredUserAccounts () {
      let that = this
      let result = {}
      result[3] = {}
      result[2] = {}
      result[1] = {}
      result[0] = {}
      if (this.filterBy) {
        for (var j in that.userAccounts) {
          for (var k in that.userAccounts[j]) {
            for (var i = 0; i < that.userAccounts[j][k].length; i++) {
              if (that.userAccounts[j][k][i].login.toLowerCase().includes(this.filterBy.toLowerCase())) {
                if (!result[j].hasOwnProperty(k)) {
                  result[j][k] = []
                }
                result[j][k].push(that.userAccounts[j][k][i])
              }
            }
          }
        }
        return result
      }
      /*
      for (var j in that.userAccounts) {
        that.userAccounts[j] = that.userAccounts[j].filter(x => x.clearance_directPayments === '') // TODO
        if (that.userAccounts[j].length === 0) {
          delete that.userAccounts[j]
        }
      }
      */
      return that.userAccounts
    }
  },
  mounted () {
  },
  methods: {
    editAccountMember (data) {
      if (this.$engine.rights.rightIs('business_members_editer', false)) {
        return
      }
      this.$engine.settings.set({currentAccountMember: data})
      // var formData = {
      //   'login': data.login,
      //   'status': data.status
      // }
      // this.$f7.formFromData('#EditAccountMemberForm', formData)
      // this.$f7.popup('.EditAccountMember')
      loadPage(this, {url: '/accountMembers/accountMemberDetail/'})
    },
    editAccountMemberMobile (data) {
      if (this.$engine.rights.rightIs('business_members_editer', false)) {
        return
      }
      this.$engine.settings.set({currentAccountMember: data})
      // var formData = {
      //   'login': data.login,
      //   'status': data.status
      // }
      // this.$f7.formFromData('#EditAccountMemberForm', formData)
      // this.$f7.popup('.EditAccountMember')
      loadPage(this, {url: '/accountMembers/edit/'})
    },
    isEmpty (map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    },
    removeAccountMember (data) {
      if (this.$engine.rights.rightIs('business_members_supprimer', false)) {
        return
      }
      const that = this
      this.$engine.settings.set({currentAccountMember: data})
      this.jsonStart = _.cloneDeep(that.$settings.currentAccountMember.id)
      that.$engine.accounts
      .deleteUserFromAccount(this.jsonStart)
      .then(() => {
        that.$bus.$emit('refresh-page-member')
        that.$f7.alert('Member deleted', 'Success', function () {
          that.$f7.closeModal()
          loadPage(that, {url: '/accountMembers/'})
        })
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
    },
    removeAccountMemberWeb (data) {
      if (this.$engine.rights.rightIs('business_members_supprimer', false)) {
        return
      }
      let that = this
      this.$f7.modal({
        title: that.$t('businessMembers.rm_member'),
        text: that.$t('businessMembers.account_member_deletion_confirmation'),
        buttons: [
          {
            text: that.$t('common.accpt'),
            onClick: function () {
              var idAccountInList = -1
              var filteredListAccount = that.filteredUserAccounts
              for (var keys in filteredListAccount) {
                for (var account in filteredListAccount[keys]) {
                  if (filteredListAccount[keys][account].id === data.id) {
                    idAccountInList = account
                    break
                  }
                }
                if (idAccountInList !== -1) {
                  filteredListAccount[keys].splice(idAccountInList, 1)
                  break
                }
              }
              that.removeAccountMember(data)
            }
          },
          {
            text: that.$t('common.cncl')
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.content-block-title {
  margin: 15px 15px 10px
}
</style>
